import {useDebugValue} from 'react';

import {useEdapOptions} from './';

function useEdap(props) {
    const {
        options
    } = useEdapOptions(props);

    const result = {
        options
    };

    useDebugValue(result);

    return result;
}

export {useEdap};
